// Utility to detect log levels in the content
const getLogLevel = (content) => {
  if (content.includes("ERROR")) return "error";
  if (content.includes("WARNING")) return "warning";
  if (content.includes("INFO")) return "info";
  if (content.includes("DEBUG")) return "debug";
  return null;
};

// Utility function to ensure correct local time zone conversion
function convertUTCToLocal(timestamp) {
  if (!timestamp) return null;
  if (timestamp.includes("+")) {
    timestamp = timestamp.split("+")[0];
  }
  // console.log('convertUTCToLocal -> timestamp', timestamp);
  const utcDate = new Date(`${timestamp}Z`); // Adding 'Z' ensures it's treated as UTC
  return utcDate.toLocaleString(undefined, { timeZoneName: "short" });
}

// Helper function to normalize timestamps
function normalizeTimestamp(timestamp) {
  // Ensure the timestamp is a valid ISO format without excessive microseconds
  const normalized = timestamp.split(".")[0]; // Trim microseconds
  return new Date(`${normalized}Z`); // Treat as UTC by appending 'Z'
}

function countLogLevels(messages) {
  const logCount = {
    ERROR: 0,
    WARNING: 0,
    INFO: 0,
    DEBUG: 0,
  };

  messages.forEach((message) => {
    if (message.content.includes("ERROR")) logCount.ERROR += 1;
    if (message.content.includes("WARNING")) logCount.WARNING += 1;
    if (message.content.includes("INFO")) logCount.INFO += 1;
    if (message.content.includes("DEBUG")) logCount.DEBUG += 1;
  });

  return logCount;
}

export { getLogLevel, convertUTCToLocal, normalizeTimestamp, countLogLevels };
